/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';
import { AppraisalMeasurements } from '../models/AppraisalMeasurements';
import { Pagination } from '../models';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppraisalMeasurementsService extends BaseApiService<AppraisalMeasurements> {
  get cacheKey(): StorageKey {
    return StorageKey.appraisalServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/appraisalMeasurements`;

    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  list(params: any = {}): Promise<Pagination<AppraisalMeasurements>> {
    return super.list({ limit: 1000, ...params });
  }

  create(model: any, isFormData = false): Promise<AppraisalMeasurements> {
    const cleanModel = { ...model };
    delete cleanModel.id;
    delete cleanModel.contractId;
    delete cleanModel.createdAt;
    delete cleanModel.updatedAt;
    delete cleanModel.deletedAt;
    return super.create(cleanModel, isFormData);
  }

  protected parse(obj) {
    const parsed = AppraisalMeasurements.parse(obj) as any;
    const { id, contractId, createdAt, updatedAt, deletedAt, ...rest } = parsed;
    return rest;
  }

  protected unparse(obj) {
    return AppraisalMeasurements.unparse(obj);
  }
  downloadMeasurementPdf(id: number) {
    const url = `${environment.omniaCoreApiUrl}/v1/report/appraisalMeasurementReport/${encodeURIComponent(id)}`;
    return this.http.get(url).pipe(catchError(this.handleError)).toPromise();
  }
}
